import * as React from "react";
const SvgAgentChatChevron = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}><path stroke="currentColor" d="m5 7 3 3 3-3" /></svg>;
export default SvgAgentChatChevron;